module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-LightItalic.efbd9a2b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-LightItalic.ttf
// module id = 523
// module chunks = 0